import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { assetsDataManagerGettingStartedRoute } from '@atlassian/jira-router-routes-assets-data-manager-getting-started-routes/src/assetsDataManagerGettingStartedRoute.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { assetsDataManagerGettingStartedEntryPoint } from '@atlassian/jira-spa-apps-assets-data-manager-getting-started-page/entrypoint.tsx';
import {
	toPackageName,
	APP_NAMES,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { getAssetsAppResources } from '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { LazyAssetsLayout, AssetsLayout } from '@atlassian/jira-assets-layout/src/ui/async.tsx';
import { AssetsPageConfigContainer } from '@atlassian/jira-assets-app-page-config-container/src/ui/async.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';

const assetsDataManagerGettingStartedPageEntryPoint = createChromelessEntryPoint({
	main: assetsDataManagerGettingStartedEntryPoint,
});

export const assetsDataManagerGettingStartedRouteEntry = createEntry(
	assetsDataManagerGettingStartedRoute,
	() => ({
		group: 'assets',
		LayoutOverrideComponent: AssetsLayout,
		PageConfigContainerOverride: AssetsPageConfigContainer,
		skeleton: Spinner,
		perfMetricKey: 'assets-data-manager-getting-started',
		pageId: () => 'spa-apps/assets-data-manager-getting-started',
		resources: getAssetsAppResources(),
		forPaint: [LazyAssetsLayout],
		entryPoint() {
			return fg('assets_data_manager_jira_spa')
				? assetsDataManagerGettingStartedPageEntryPoint
				: undefined;
		},
		component: fg('assets_data_manager_jira_spa') ? undefined : ErrorPagesNotFound,
		meta: {
			reporting: {
				id: APP_NAMES.ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE,
				packageName: toPackageName(APP_NAMES.ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE),
				teamName: 'Aurum',
			},
		},
	}),
);
